/**
 * 周边数据
 * 
 * @Author: Focci
 * @Date: 2024-07-02 16:15:19
 * @Last Modified by: Focci
 * @Last Modified time: 2024-07-02 16:15:19
 */

'use client'

import PropTypes from 'prop-types'
import useLazyComponent from '@hook/useLazyComponent'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { useCallback, useState } from 'react'
import { Waypoint } from 'react-waypoint'
import { SurroundingFacilitiesSkeleton } from '../surrounding-facilities/SurroundingFacilities'
import PropertyItemScoff from '../PropertyItemScoff'

export default function SurroundingData({ data, house }) {
  const { Wedget, getWedget, ready } = useLazyComponent()
  const [enter, setEnter] = useState(false)
  
  const handleEnter = useCallback(async () => {
    setEnter(true)
    getWedget(() => import('./SurroundingDataBody'))
  }, [getWedget])
  
  return (
    <Waypoint onEnter={handleEnter}>
      <div>
        <PropertyItemScoff
          title={
            <div className="flex items-center gap-1 relative">
              <h2 className="text-f1.2 font-medium">
                {data?.title}
              </h2>
              {data?.titleTip && (
                <div className="group/calc inline-flex">
                  <div className="inline-flex items-center text-helper gap-1 cursor-pointer">
                    <ErrorOutlineIcon />
                  </div>
                  <div className="hidden group-hover/calc:flex absolute z-50 top-full left-0 w-[20rem] max-w-full p-2 rounded-md bg-black text-white text-f.7">
                    {data.titleTip}
                  </div>
                </div>
              )}
            </div>
          }
          moduleName={data?.title}
          id="module-surrounding-data"
        >
          {
            !enter
              ? <div className="min-h-[20rem]" />
              : ready
                ? <Wedget data={data} house={house} />
                : (
                  <div className="min-h-[20rem] grid grid-cols-1 md:grid-cols-2 gap-6">
                    <SurroundingFacilitiesSkeleton />  
                    <SurroundingFacilitiesSkeleton />
                  </div>
                ) 
          }
        </PropertyItemScoff>
      </div>
    </Waypoint>
  )
}

SurroundingData.propTypes = {
  data: PropTypes.object,
}
